import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getLicenseLimits, updateLicenseLimits} from 'src/openapi/admin/apis/LicenseLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {Limit} from 'src/openapi/admin/models/Limit';

type Props = {
    licenseId: number,
};

export const useLicenseLimits = ({licenseId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getLicenseLimits({licenseId}, {signal}),
    ), [licenseId, apiDispatch]);

    const saveDispatchAction = useCallback((limit: Limit[], signal: AbortSignal) => apiDispatch(
        updateLicenseLimits({licenseId, limit}, {signal}),
    ), [licenseId, apiDispatch]);

    return useCommonDataHook({
        initValue: [],
        getDispatchAction,
        saveDispatchAction,
    });
};
